import BreadCrumb from "../screens/MobileCommon/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/Mobilelayout/admin-dashboard";
import DocumentList from "../screens/MobileInfoView/DocumentList";

const breadCrumbData = [{ link: "/view-info-list", name: "Info List" }];

const UploadDocumentsList = () => (
  <>
    <LayoutContainer>
      {/* <BreadCrumb data={breadCrumbData} /> */}
      <DocumentList />
    </LayoutContainer>
  </>
);

export default UploadDocumentsList;
